module.exports = __webpack_public_path__ + "img/bs1.396ae511.png";